import React from "react";
import { ASSETS, EMAIL, SOCIALS, MAIN_SITE } from "../lib/constants";

export default function Footer() {
  return (
    <footer className="border-t border-white/10 py-14 px-6 md:px-10" data-testid="footer">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-start md:items-center justify-between gap-8">
        <img src={ASSETS.logo} alt="Casey Muze" className="h-12 w-auto" />
        <div className="flex flex-wrap gap-6 font-mono text-[11px] tracking-[0.2em] uppercase text-fg/60">
          <a href={MAIN_SITE} target="_blank" rel="noopener noreferrer" className="hover:text-fg transition-colors" data-testid="footer-mainsite">
            Braced No More ↗
          </a>
          {SOCIALS.map((s) => (
            <a key={s.label} href={s.href} target="_blank" rel="noopener noreferrer" className="hover:text-fg transition-colors" data-testid={`social-${s.label.toLowerCase()}`}>
              {s.label}
            </a>
          ))}
          <a href={`mailto:${EMAIL}`} className="hover:text-fg transition-colors text-primary-c" data-testid="footer-email">{EMAIL}</a>
        </div>
      </div>
      <p className="max-w-7xl mx-auto mt-8 font-mono text-[10px] tracking-[0.15em] uppercase text-fg/30">
        © {new Date().getFullYear()} Casey Muze · AvenueSpeak LLC · Rhythm &amp; Restoration
      </p>
    </footer>
  );
}
